import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import onlineUsersSelector from 'Selectors/onlineUsersSelector';
import UserIcon from 'Components/common/UserIconComponent';
import Date from 'Components/common/dateComponent';

export class OnlineUsersListComponent extends React.Component {
	buildUser = ( user ) => {
		if( user.userName === 'Guest' ) {
			return null;
		}
		return (
			<li key={ user.id }>
				<div className="post">
					<div className="left">
						<UserIcon user={ user } layout="userprofile"/>
					</div>
					<div className="right">
						<div className="username">{ user.userName ? user.userName : 'Loading...' }</div>
						<div className="since">Last active <Date timestamp={ user.lastActivity } /></div>
					</div>
				</div>
			</li>
		);
	};


	buildPage = ( pageNum ) => {
		const { entities, result } = this.props.onlineUsers;

		let onlineUsers = result.online.filter( e => entities.online[ e ] && entities.online[ e ].page === pageNum ),
			usersList = onlineUsers.map( ( id, i ) => this.buildUser( entities.online[ id ] ) );

		return (
			<ul key={pageNum} className={`scroll_page page_${pageNum}`}>
				{ usersList }
			</ul>
		)
	};

	onlineUsersListPage () {
		return this.props.pages.map( ( pageNum ) => this.buildPage( pageNum ) );
	}

	render() {
		return (
			<div ref={ this.props.listRef } style={{ paddingBottom: '50px' }}>
				{ this.onlineUsersListPage() }
			</div>
		);
	}
}

OnlineUsersListComponent.propTypes = {
	dispatch: PropTypes.func.isRequired,
	pages: PropTypes.array.isRequired
};

export default connect( onlineUsersSelector )( OnlineUsersListComponent );



// WEBPACK FOOTER //
// ./src/components/onlineusers/OnlineUsersListComponent.js